<template>
    <div class="compliance">
        <div class="compliance-fixed">
            <strong><a class="compliance-a" href="#" @click.prevent="externalToggleComplianceControl()">Compliance &gt;</a></strong>
        </div>
        <div class="compliance-toggled">
            <button id="compliance-toggle" @click="externalToggleCompliance()" href="#">Toggle On</button><span id="compliance-notes"></span>
        </div>
        <div id="compliance-tooltip"></div>
    </div>
</template>
    <style>
        .compliance {
            position: sticky;
            display: inline-block;
            border-radius: 5px;
            top: 80px;
            left: 10px;
            height: 44px;
            max-width: 550px;
            padding: 12px 12px;
            background-color: green;
            color: #fff;
            font-size: 14px;
            z-index: 10001;
        }

        .compliance-fixed {
            width: 90px;
            float: left;
        }

        div.compliance-fixed a:hover {
            color: lightgray;
            text-decoration: none;
        }

        div.compliance-fixed a {
            color: white;
        }

            div.compliance-fixed a:hover {
                text-decoration: none;
            }

        .compliance-toggled {
            float: left;
            min-width: 80px;
            display: none;
        }

        #compliance-notes {
            padding-left: 15px;
        }

        #compliance-toggle {
            border: none;
            outline: none;
            border-radius: 5px;
            margin-left: 15px;
        }
        #compliance-tooltip {
            position: absolute;
            display: inline-block;
            color: black;
            background-color: lightgray;
            z-index: 10001;
        }

        .compliance-highlight {
            background-color: #efdb23;
        }

        .co-field-highlight {
            background-color: lightgreen;
        }

    </style>
    <script>
        export default {
            name: "compliance",
            mounted() {
                const script = document.createElement("script");
                script.src =
                    "/js/common/compliance.js";
                document.body.appendChild(script);
            },
            methods: {
                externalToggleComplianceControl() {
                    if (window.toggleComplianceControl) {
                        window.toggleComplianceControl();
                    } else {
                        console.warn("toggleComplianceControl is not loaded yet.");
                    }
                },
                externalToggleCompliance() {
                    if (window.toggleCompliance) {
                        window.toggleCompliance();
                    } else {
                        console.warn("toggleCompliance is not loaded yet.");
                    }
                }
            }
        }
    </script>

